// extracted by mini-css-extract-plugin
module.exports = {"projects":"Projects_projects__1diOE","title":"Projects_title__1CVoY"};